module.exports = __webpack_public_path__ + "static/media/perfil.c7ddc333.svg";